<ngx-loading-bar [height]="'3px'"></ngx-loading-bar>
<router-outlet></router-outlet>

<!-- Custom modal setup -->
<div class="right-panel">
    <div id="right-panel-container" class="hidden-panel"></div>
</div>
<div id="overlay" class="hidden"></div>
